export const paymentMethods = {
  PAYPAL: 'paypal',
  STRIPE: 'stripe',
  BOLETO: 'boleto',
};

export const paymentIconGlyphs = {
  VISA: 'visa',
  MASTER_CARD: 'master-card',
  AMERICAN_EXPRESS: 'american-express',
  PAYPAL: 'paypal',
};
